module.exports = __webpack_public_path__ + "img/computer.b499f799.png";